<div id="contextButtons" (click)="$event.stopPropagation()">
    <div *ngFor="let context of 'contexts.TITLE' | translate; let i = index">
      <button id="{{'btnContext' + i}}" (click)="onClickChangeContext(i)" [ngClass]="currentContext == i ? 'button-context active' : 'button-context inactive'">
        <span style="padding:5px"> {{ context }}</span>
        <span [ngClass]="currentContext == i ? 'icon-check' : 'icon-arrow-right' "></span>
      </button>
      <span *ngIf="currentContext == i"> {{ 'infoLocation.TITLE' | translate }}</span>
    </div>
  </div>